import styled from '@emotion/styled'

const CenterContainer = styled.div`
  max-width: 960px;
  width: 100%;
  height: 60%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(
    104.25deg,
    rgba(255, 255, 255, 0.08) -12.9%,
    rgba(255, 255, 255, 0.008) 121.7%
  );
  backdrop-filter: blur(10px);
  box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.2);
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 425px) {
    height: 75%;
    padding: 15px;
  }

  & > div {
    text-align: center;
  }

  &::before {
    box-sizing: border-box;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    border: 1px solid transparent;
    border-radius: inherit;
    background: linear-gradient(
          300deg,
          rgba(255, 255, 255, 0.5) 0%,
          rgba(255, 255, 255, 0) 25%
        )
        border-box,
      linear-gradient(
          140deg,
          rgba(255, 255, 255, 0.5) 0%,
          rgba(255, 255, 255, 0) 40%
        )
        border-box;

    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
`

export default CenterContainer
